import { PureComponent } from 'react'
import always from 'ramda/es/always'
import cn from 'classnames'

import FacebookIcon from 'static/images/facebookIcon.svg'
import { Button } from 'components/Button'
import i18n from 'services/i18n'

import s from './FacebookLoginButton.module.scss'

export class FacebookLoginButton extends PureComponent {
  onButtonClick = () => {
    const { onClick, disabled, isLoading } = this.props

    return (disabled || isLoading)
      ? always()
      : onClick()
  }

  getLabel = () => {
    const label = this.props.isRegister
      ? i18n.t('home.register')
      : i18n.t('home.signIn')

    return i18n.t('home.withFacebook', { label })
  }

  render() {
    const { invitationLoginMethod, disabled } = this.props

    return (
      <Button
        variant="contained"
        className={cn(s.container, disabled && invitationLoginMethod && s.disabled)}
        onClick={this.onButtonClick}
      >
        <img src={FacebookIcon} className={s.icon} alt="Facebook" aria-hidden="true" />
        {this.getLabel()}
      </Button>
    )
  }
}
